import { useTranslation } from 'react-i18next';
import { Grid } from 'src/components/Grid';
import { Skeleton } from 'src/components/Skeleton';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { FranchiseFeePayer } from 'src/models/hq/franchise-fee-payer/_types';

export function PayerDetails({
  payer,
  isLoading,
}: {
  payer?: FranchiseFeePayer;
  isLoading?: boolean;
}) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'franchiseFees.payouts.initiateDialog',
  });
  const payerName = payer?.name;
  const payerEmail = payer?.email;
  const payerPlatforms = payer?.platformNames;

  return (
    <>
    <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
      {t('payerInformation')}
    </Typography>

    {isLoading ? (
      <Stack spacing={2}>
        <Skeleton variant="text" width="60%" height={24} />
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="text" width="70%" height={20} />
      </Stack>
    ) : payerName ? (
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <Typography variant="body2" color="text.secondary">
            {t('payerName')}
          </Typography>
          <Typography variant="body1" fontWeight={500}>
            {payerName}
          </Typography>
        </Grid>

        {payerEmail && (
          <Grid size={{ xs: 6 }}>
            <Typography variant="body2" color="text.secondary">
              {t('payerEmail')}
            </Typography>
            <Typography variant="body1">{payerEmail}</Typography>
          </Grid>
        )}

        {payerPlatforms && payerPlatforms.length > 0 && (
          <Grid size={{ xs: 6 }}>
            <Typography variant="body2" color="text.secondary">
              {t('associatedPlatforms')}
            </Typography>
            <Typography variant="body1">
              {payerPlatforms.join(', ')}
            </Typography>
          </Grid>
        )}
      </Grid>
    ) : (
      <Typography color="error">{t('noPayerFound')}</Typography>
    )}
  </>
  );
}
